import { Typography } from 'fronton-react';
import React from 'react';
import { stepsDb } from './steps-db';
import { Step } from './components/step';
import { stepsContainerStyles } from './styles';

export const Steps = () => {
	return (
		<div>
			<Typography variant="h2">Этапы выполнения работ</Typography>
			<div className={stepsContainerStyles}>
				{stepsDb.map(el => (
					<Step {...el} key={el.number} />
				))}
			</div>
		</div>
	);
};
